import "bootstrap";
import "../scss/main.scss";
require("easy-autocomplete");
import * as feather from "feather-icons";
import "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset";

import FoundationCms from "../js/common/foundation.cms";

feather.replace();

var foundationCms = new FoundationCms();
foundationCms.init();

/* ::::: old main.js ported to ts above / new additions below ::::: */

import "../js/script";
import "./search.ts";
import "../js/popupTickList";
import "../js/radioSwitchable";
import "../js/passwordReveal";
import "../js/modal";
import "../js/toggleFullList";
import "../js/careerPhasesCounter";
// import "../js/validation/step2NextCheck";